var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table-container" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { xs: 24, sm: 24, md: 12, lg: 24, xl: 24 } },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  ref: "tableSort",
                  attrs: { data: _vm.list, border: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "序号",
                      align: "center",
                      width: "80",
                      prop: "seq",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(" " + _vm._s(scope.row.seq || "-") + " "),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "企业名称" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(" " + _vm._s(scope.row.name || "-") + " "),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "report_year", label: "报送年度" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " + _vm._s(scope.row.report_year || "-") + " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "公示日期", prop: "report_date" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " + _vm._s(scope.row.report_date || "-") + " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      width: "100px",
                      fixed: "right",
                      align: "center",
                      fit: "true",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content: "查看详情",
                                  placement: "top-start",
                                },
                              },
                              [
                                _c("el-button", {
                                  attrs: {
                                    size: "mini",
                                    type: "primary",
                                    icon: "el-icon-document",
                                    circle: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.showDetail(scope.row)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.total > 0
        ? _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { xs: 24, sm: 24, md: 12, lg: 24, xl: 24 } },
                [
                  _c(
                    "el-card",
                    [
                      _c("el-pagination", {
                        attrs: {
                          "current-page": _vm.queryForm.pageNum,
                          "page-size": _vm.queryForm.pageSize,
                          total: _vm.total,
                          background: _vm.background,
                        },
                        on: {
                          "current-change": _vm.handleCurrentChange,
                          "size-change": _vm.handleSizeChange,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "年报详情",
            visible: _vm.flag,
            "close-on-click-modal": false,
            width: "70%",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.flag = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "table",
            {
              staticClass: "info-table",
              staticStyle: { width: "100%", height: "100%" },
              attrs: { cellspacing: "0" },
            },
            [
              _c("tbody", [
                _c("tr", [
                  _c("td", [_vm._v("从业人数")]),
                  _c("td", [_vm._v(_vm._s(_vm.report.collegues_num || "-"))]),
                  _c("td", [_vm._v("实际员工数量")]),
                  _c("td", [_vm._v(_vm._s(_vm.report.prac_person_num || "-"))]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("营业总收入")]),
                  _c("td", [_vm._v(_vm._s(_vm.report.sale_income || "-"))]),
                  _c("td", [_vm._v("纳税总额")]),
                  _c("td", [_vm._v(_vm._s(_vm.report.tax_total || "-"))]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("负债总额")]),
                  _c("td", [_vm._v(_vm._s(_vm.report.debit_amount || "-"))]),
                  _c("td", [_vm._v("资产总额")]),
                  _c("td", [_vm._v(_vm._s(_vm.report.total_equity || "-"))]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("净利润")]),
                  _c("td", [_vm._v(_vm._s(_vm.report.net_amount || "-"))]),
                  _c("td", [_vm._v("主营业务收入")]),
                  _c("td", [
                    _vm._v(_vm._s(_vm.report.serv_fare_income || "-")),
                  ]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("所有者权益合计")]),
                  _c("td", [_vm._v(_vm._s(_vm.report.profit_reta || "-"))]),
                  _c("td", [_vm._v("利润总额")]),
                  _c("td", [_vm._v(_vm._s(_vm.report.profit_total || "-"))]),
                ]),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }